import React from 'react';
import FilterBar from '../FilterBar/FilterBar';
import ProductFiltering from '../ProductFiltering/ProductFiltering';
import ProductListing from '../ProductListing/ProductListing';
import SearchResultLinkTab from './SearchResultLinkTab';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import ActiveFilterChips from '../ActiveFilterChips/ActiveFilterChips';
import MobileStickyFilterBar from '../FilterBar/MobileStickyFilterBar';
import MobileProductCountBar from '../FilterBar/MobileProductCountBar';

const SearchResult = (props) => {
  const { activeTab = 'products' } = useTypedSelector<any>(
    (state) => state.search
  );

  return (
    <>
      {props.productListing?.totalProductsCount > 0 &&
        activeTab == 'products' && (
          <div className="container relative">
            <div className="sticky top-0 z-20 hidden lg:block">
              <FilterBar />
            </div>
            <div className="sticky top-0 z-10 -ml-4 -mr-4 lg:hidden">
              <MobileStickyFilterBar />
            </div>
            <div className="lg:hidden">
              <MobileProductCountBar />
            </div>
            <div className="flex">
              <aside
                id="category-filter-aside"
                className="duration-1500 relative w-0 transition-[width] ease-in-out [&.filter-visible]:mr-4 [&.filter-visible]:w-[300px] [&.filter-visible_.filter-container]:translate-x-0 [&_.filter-container]:-translate-x-[300px] [&_.filter-container]:transition-transform [&_.filter-container]:duration-150 [&_.filter-container]:ease-in-out"
              >
                <ProductFiltering />
              </aside>
              <div className="flex-1">
                <div className="mb-6 md:mb-16">
                  <ProductListing />
                </div>
              </div>
            </div>
          </div>
        )}
      {props.brandListing?.total > 0 && activeTab == 'brands' && (
        <SearchResultLinkTab items={props.brandListing.items} />
      )}
      {props.pagesListing?.total > 0 && activeTab == 'pages' && (
        <SearchResultLinkTab items={props.pagesListing.items} />
      )}
      {props.categoryListing?.total > 0 && activeTab == 'categories' && (
        <SearchResultLinkTab items={props.categoryListing.items} />
      )}
    </>
  );
};

export default SearchResult;
